module.exports = "<survey-editor survey-id=surveyId action-type=actionType></survey-editor> ";


//////////////////
// WEBPACK FOOTER
// ./app/settings/surveys/survey-edit.html
// module id = 883
// module chunks = 0